/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'people.menu.renotify.flag.description':
    "Nous envoyons un rappel par e-mail à tout le monde. Cette opération peut prendre jusqu'à une minute.",
  'people.menu.renotify.flag.description.confluence': 'Envoyer un rappel à des coéquipiers',
  'people.menu.renotify.flag.title': 'Envoi de rappels',
  'people.menu.renotify.flag.title.confluence': "Nous renvoyons actuellement l'e-mail d'invitation",
  'people.menu.renotify.menu.description':
    "{userCount, plural, one {{userCount,number} personne n'a pas accepté son invitation {product}. Découvrez qui manque et envoyez-lui un rappel.} other {{userCount,number} personnes n'ont pas accepté leur invitation {product}. Découvrez qui manque et envoyez des rappels.}}",
  'people.menu.renotify.menu.description.confluence':
    "Certaines personnes n'ont pas accepté leur invitation Confluence. Découvrez qui manque et envoyez des rappels.",
  'people.menu.renotify.menu.dismiss': 'Ignorer',
  'people.menu.renotify.menu.dismiss.confluence': 'Pas maintenant',
  'people.menu.renotify.menu.remind': "Envoyer un rappel aux membres de l'équipe",
  'people.menu.renotify.menu.remind.confluence': 'Envoyer un rappel à des coéquipiers',
  'people.menu.renotify.menu.title': "Est-ce que tout le monde est sur la même longueur d'onde ?",
  'people.menu.renotify.modal.copied': 'Lien copié',
  'people.menu.renotify.modal.copy': "Copier le lien d'invitation",
  'people.menu.renotify.modal.description':
    "Nous pouvons envoyer un rappel par e-mail aux membres manquants, ou vous pouvez partager vous-même le lien d'invitation.",
  'people.menu.renotify.modal.description.confluence':
    "Renvoyez l'e-mail d'invitation, ou copiez et partagez le lien d'invitation.",
  'people.menu.renotify.modal.dismiss': 'Annuler',
  'people.menu.renotify.modal.resend': 'Envoyer un rappel',
  'people.menu.renotify.modal.resend.confluence': "Renvoyer l'invitation",
  'people.menu.renotify.modal.title': 'Envoyer un rappel aux membres manquants',
  'people.menu.renotify.modal.title.confluence': 'Envoyer un rappel aux coéquipiers manquants',
  'ptc.pm.collaborators.title': 'Vos collaborateurs',
  'ptc.pm.error-heading': "Un problème s'est produit",
  'ptc.pm.error-image-alt-text': 'Un robot cassé et un certain nombre de personnes affairées à le réparer.',
  'ptc.pm.error-text':
    "Nous gardons un œil sur ces erreurs, mais n'hésitez pas à nous contacter si l'actualisation de la page ne résout pas le problème.",
  'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} membre} other {{memberCount,number} membres}}',
  'ptc.pm.people': 'Personnes',
  'ptc.pm.teams': 'Équipes',
  'ptc.pm.view-your-profile': 'Afficher votre profil',
  'ptc.pm.your-teams.title': 'Vos équipes',
};
